<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
      ref="editForm"
      :rules="rules"
    >
      <el-row>
        <el-form-item label="客户名称" prop="customerName">
          <el-input
            size="small"
            v-model="editForm.customerName"
            auto-complete="off"
            placeholder="客户名称"
            disabled
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="业务员" prop="inSalesman">
          <el-autocomplete
            size="small"
            style="width: 220px"
            v-model="editForm.inSalesman"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, editForm, 'inSalesman')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="进价（%）" prop="inPercentage">
          <el-input-number
            :min="0"
            :max="100"
            :controls="false"
            size="small"
            v-model="editForm.inPercentage"
            placeholder="进价（%）"
          ></el-input-number>
        </el-form-item>
      </el-row>
<!--      <el-row>-->
<!--        <el-form-item label="票据数量" prop="allCount">-->
<!--          <el-input-number-->
<!--            :min="0"-->
<!--            :step="1"-->
<!--            step-strictly-->
<!--            :controls="false"-->
<!--            size="small"-->
<!--            v-model="editForm.allCount"-->
<!--            placeholder="票据数量"-->
<!--            disabled-->

<!--          ></el-input-number>-->
<!--        </el-form-item>-->
<!--      </el-row>-->
      <el-row>
        <el-form-item label="入库状态" prop="inStatus">
          <el-select
            size="small"
            v-model="editForm.inStatus"
            placeholder="请选择"
          >
            <el-option
              v-for="type in statusType"
              :label="type.key"
              :value="type.value"
              :key="type.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报价员" prop="inBidder">
          <el-autocomplete
            size="small"
            style="width: 220px"
            v-model="editForm.inBidder"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, editForm, 'inBidder')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报价成本（%）" prop="inOffer">
          <el-input
            size="small"
            v-model="editForm.inOffer"
            auto-complete="off"
            placeholder="报价成本（%）"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <Payment
      :visible.sync="visiblePayment"
      :editForm="editForm"
      @confirm="handlePayment"
    ></Payment>
    <Salesman
      :visible.sync="salesmanVisible"
      @confirm="handleConfirmSelectSaleman"
    ></Salesman>
  </el-dialog>
</template>

<script>
import Payment from "./payment.vue";
import Salesman from "@/views/components/salesman";
import { storeTicket } from "@/api/ticket/ticket";
import { listSalesman } from "@/api/system/user";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    Payment,
    Salesman,
  },
  data() {
    return {
      salesmanVisible: false,
      statusType: [
        { key: "空", value: "" },
        { key: "扣息打款", value: "扣息打款" },
        { key: "打全款", value: "打全款" },
        { key: "扣息有小款", value: "扣息有小款" },
        { key: "回全款有小款", value: "回全款有小款" },
      ],
      visiblePayment: false,
      rules: {
        inSalesman: [
          { required: true, message: "请输入业务员", trigger: "blur" },
        ],
        inPercentage: [
          { required: true, message: "请输入进价（%）", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleConfirmSelectSaleman(data, originData, type) {
      if (data) {
        if (type === "inSalesman") {
          originData.inSalesman = data.realName;
          originData.inSalesmanId = data.id;
        } else if (type === "inBidder") {
          originData.inBidder = data.realName;
          originData.inBidderId = data.id;
        }
      }
    },
    handleSerachSalesman() {
      this.salesmanVisible = true;
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          storeTicket(this.editForm)
            .then(() => {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err,
                type: "error",
              });
            });
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
      this.$emit("confirm");
    },
    handlePayment() {
      this.handleClose();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ticket/ticket-store/add-edit/index.vue